export default "__VITE_ASSET__B$HVBuly__"